import { useQuery } from '@tanstack/react-query';
import { getInsuranceContractByRegion } from '../api';
import { INSURANCE_QUERY_KEY } from '../constants';
import { InsuranceContractByRegionParams } from '../model';

export const useInsuranceContractByRegion = (
  params?: InsuranceContractByRegionParams,
) => {
  return useQuery({
    queryKey: [INSURANCE_QUERY_KEY.CONTRACT_BY_REGION, params],
    queryFn: () => getInsuranceContractByRegion(params),
    enabled: Boolean(params?.year),
  });
};
